import './Navbar.css'
import { useLocation } from 'react-router-dom'
import NavbarLinks from './NavbarLinks'
import MobileNavigation from './MobileNavigation'
import TopBar from '../topBar/TopBar'
import { memo } from 'react'

function Navbar() {
  const location = useLocation()

  if (!location?.pathname?.includes('/admin')) {
    return (
      <div className='navbar-container'>
        <div className='topbar-component'>
          <TopBar />
        </div>
        <nav className='Nav-bar'>
          <NavbarLinks />
          <MobileNavigation />
        </nav>
      </div>
    )
  }
}

export default memo(Navbar)
